export default __webpack_public_path__ + "static/media/search-icon.6b2403bb.svg";